import { ITabItem } from '@components/common/Tabs/Tabs';

import { ITabProps } from './interfaces';

import { EChannelFields } from './AddKpiAlertChannel/enums';
import { EConditionFields } from './AddKpiAlertCondition/enums';
import { EScheduleFields } from './AddKpiAlertSchedule/enums';

import { basicInformationFields, basicInformationSchema } from './AddKpiAlertBasicInformation/schema';
import { channelFields, channelSchema } from './AddKpiAlertChannel/schema';
import { checkForFields, checkForSchema } from './AddKpiAlertCheckFor/schema';
import {
	conditionFields,
	conditionSchema,
} from './AddKpiAlertCondition/schema';
import { ERecipientFields } from './AddKpiAlertRecipient/AddKpiAlertRecipient';
import { recipientFields, recipientSchema } from './AddKpiAlertRecipient/schema';
import { scheduleFields, scheduleSchema } from './AddKpiAlertSchedule/schema';
import AddKpiAlertBasicInformation from './AddKpiAlertBasicInformation';
import AddKpiAlertChannel from './AddKpiAlertChannel';
import AddKpiAlertCheckFor from './AddKpiAlertCheckFor';
import AddKpiAlertCondition from './AddKpiAlertCondition';
import AddKpiAlertRecipient from './AddKpiAlertRecipient';
import AddKpiAlertSchedule from './AddKpiAlertSchedule';
import { ETabsIds } from './tabsIds';

export const initialTabs: ITabItem<ITabProps>[] = [
	{
		id: ETabsIds.basicInformation,
		name: 'Basic information',
		schema: basicInformationSchema,
		isActive: true,
		component: AddKpiAlertBasicInformation,
		fields: Object.keys(basicInformationFields),
		isDisabled: false,
	},
	{
		id: ETabsIds.checkFor,
		name: 'Check for',
		isActive: false,
		schema: checkForSchema,
		component: AddKpiAlertCheckFor,
		fields: Object.keys(checkForFields),
		isDisabled: true,
	},
	{
		id: ETabsIds.condition,
		name: 'Condition',
		isActive: false,
		schema: conditionSchema,
		component: AddKpiAlertCondition,
		fields: Object.keys(EConditionFields),
		isDisabled: true,
	},
	{
		id: ETabsIds.schedule,
		name: 'Schedule',
		isActive: false,
		schema: scheduleSchema,
		component: AddKpiAlertSchedule,
		fields: Object.keys(EScheduleFields),
		isDisabled: true,
	},
	{
		id: ETabsIds.recipient,
		name: 'Recipient',
		isActive: false,
		schema: recipientSchema,
		component: AddKpiAlertRecipient,
		fields: Object.keys(ERecipientFields),
		isDisabled: true,
	},
	{
		id: ETabsIds.channel,
		name: 'Channel',
		isActive: false,
		schema: channelSchema,
		component: AddKpiAlertChannel,
		fields: Object.keys(EChannelFields),
		isDisabled: true,
	},
];

export const ETabIdsAndFields = {
	[ETabsIds.basicInformation]: Object.keys(basicInformationFields),
	[ETabsIds.checkFor]: Object.keys(checkForFields),
	[ETabsIds.condition]: Object.keys(conditionFields),
	[ETabsIds.schedule]: Object.keys(scheduleFields),
	[ETabsIds.recipient]: Object.keys(recipientFields),
	[ETabsIds.channel]: Object.keys(channelFields),
} as const;
